module.exports = __webpack_public_path__ + "static/loader-231a3b2622943af6a0f3946acbe9fd65.gif";